import DOMPurify from "dompurify";

/**
 * Sanitize HTML to prevent XSS attacks.
 * Use this wherever dangerouslySetInnerHTML is needed.
 */
export const sanitizeHtml = (dirty) => {
  if (!dirty) return "";
  return DOMPurify.sanitize(dirty);
};
